import React, { useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, RowStyle } from 'ag-grid-community';
import { formatValueAsString } from '../../../../../../utils/helpers';
import { themeBalham } from 'ag-grid-enterprise';
import { IAerEstimator } from '../../../../greenTypes';

interface IHistoricalPerformanceProps {
	data: IAerEstimator[];
}
const HistoricalPerformance: React.FC<IHistoricalPerformanceProps> = ({ ...props }) => {
	const gridRef = useRef<any>(null);

	const onGridReady = (params: any) => {
		gridRef.current = params.api;
		gridRef.current!.autoSizeAllColumns();
	};
	
	const columnDefs = useMemo<ColDef[]>(
		() => [
			{
				headerName: 'Year',
				field: 'year',
				cellStyle: { fontWeight: 'bold' },
				headerClass: 'custom-header',
				headerTooltip: 'Year',
				valueFormatter: (params: any) => {
					return params.value;
				},
			},
			{
				headerName: 'AER / cgDIST (TtW)',
				field: 'aer',
				headerClass: 'custom-header',
				headerTooltip: 'AER / cgDIST (TtW)',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},
			{
				headerName: 'AERe / cgDISTe (WtW)',
				field: 'aerWtw',
				headerClass: 'custom-header',
				headerTooltip: 'AERe / cgDISTe (WtW)',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},
			{
				headerName: 'CII Score',
				field: 'ciiScore',
				headerClass: 'custom-header',
				headerTooltip: 'CII Score',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},

			{
				headerName: 'CII Band',
				field: 'ciiValue',
				headerClass: 'custom-header',
				headerTooltip: 'CII Band',
				valueFormatter: (params: any) => params.value || '-',
			},
			{
				headerName: 'PP Trajectory: Minimum',
				field: 'ppTrajectoryMinimum',
				headerClass: 'custom-header',
				headerTooltip: 'PP Trajectory: Minimum',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},
			{
				headerName: 'Alignment %',
				field: 'alignmentMin',
				headerClass: 'custom-header',
				headerTooltip: 'Alignment %',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},
			{
				headerName: 'PP Trajectory: Striving',
				field: 'ppTrajectoryStriving',
				headerClass: 'custom-header',
				headerTooltip: 'PP Trajectory: Striving',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},
			{
				headerName: 'Alignment %',
				field: 'alignmentStriving',
				headerClass: 'custom-header',
				headerTooltip: 'Alignment %',
				valueFormatter: (params: any) => formatValueAsString(params.value, { maximumFractionDigits: 1 }, '-', '', ''),
			},
		],
		[],
	);

	const rowData = props.data;

	const defaultColDef = {
		resizable: true,
		sortable: true,
		filter: false,
	};

	const getRowStyle = (params: any): RowStyle | undefined => {
		if (params.data?.year?.toString().includes('F')) {
			return { backgroundColor: '#DEF7FC' }; // Light red background
		}
		return undefined; // Correct way to return no style
	};

	return (
		<AgGridReact
			ref={gridRef}
			columnDefs={columnDefs}
			rowData={rowData}
			defaultColDef={defaultColDef}
			theme={themeBalham}
			onGridReady={onGridReady}
			getRowStyle={getRowStyle} // ✅ Apply row styling here
		/>
	);
};

export default HistoricalPerformance;
